// src/components/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function ProtectedRoute() {
  const user = useAuth();
  const location = useLocation();

  // enquanto carrega, não renderiza nada (ou um loader)
  if (user === undefined) return <div>Carregando...</div>;

  // se não logado, redireciona para /login, guardando a rota desejada
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // se logado, renderiza o componente filho (Outlet)
  return <Outlet />;
}
